import { PhotoPlaceholder } from '../components/PhotoPlaceholder';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import styles from './AboutPage.module.css';

const VALUES = [
  {
    title: 'Integrity',
    body: 'We tell you what a project actually costs and how long it actually takes — no surprises at closing.',
  },
  {
    title: 'Quality',
    body: 'We hold every trade on the job site to the same standard we would want in our own home.',
  },
  {
    title: 'Partnership',
    body: "You're part of every major decision on your build, from the first walkthrough to the final punch list.",
  },
];

export function AboutPage() {
  useDocumentTitle('About');

  return (
    <>
      <div className="container">
        <header className={styles.pageHeader}>
          <h1 className={styles.title}>Building homes people are proud to live in</h1>
          <p className={styles.lede}>
            Herculean Homes is a custom home builder built on a simple idea: a home should
            be built as well as it looks. We handle every stage of the build ourselves —
            design, permitting, construction, and finishing — so nothing gets lost between
            contractors.
          </p>
        </header>

        <section className={styles.values}>
          {VALUES.map((value) => (
            <div key={value.title} className={styles.value}>
              <h2 className={styles.valueTitle}>{value.title}</h2>
              <p className={styles.valueBody}>{value.body}</p>
            </div>
          ))}
        </section>
      </div>

      <section className={styles.founder}>
        <div className={`container ${styles.founderInner}`}>
          <PhotoPlaceholder
            className={styles.founderPhoto}
            label="Placeholder — portrait of Brad, once a photo is available"
          />
          <div className={styles.founderCopy}>
            <span className="section-kicker section-kicker-onlight">
              Who&rsquo;s behind it
            </span>
            <h2 className={styles.founderTitle}>Brad</h2>
            <p className={styles.founderBody}>
              Brad founded Herculean Homes. [ Founder bio — background, experience, and
              building philosophy, to be added once provided. ]
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
